(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/models/accordion-structure-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/models/accordion-structure-abtest.js');
'use strict';

const accordionabtest = [{
  id: 0,
  title: 'Hur påverkas lagda spel?',
  content: "Om du har betalt f\xF6r ett spel finns spelet kvar."
}, {
  id: 1,
  title: 'Hur påverkas Spela tillsammans?',
  content: "Om du tar en spelpaus l\xE4mnar du lag d\xE4r du \xE4r aktiv lagmedlem. Pengar som \xF6verf\xF6rts till laget som inte hunnit anv\xE4ndas till spel f\xF6rs tillbaka till ditt spelkonto. \n\n\n    Om du \xE4r lagledare och tar en spelpaus avslutas hela laget. Pengar som \xF6verf\xF6rts till laget som inte hunnit anv\xE4ndas till spel f\xF6rs tillbaka till respektive spelares konto."
}, {
  id: 2,
  title: 'Hur påverkas flerveckorsspel?',
  content: "\xC4ven om du tar en spelpaus g\xE4ller redan betalda spel tidsperioden ut."
}, {
  id: 3,
  title: 'Vad betyder “Tills vidare”?',
  content: 'Om du har tagit en spelpaus som är 1 år eller längre behöver du kontakta kundservice för att häva din spelpaus. Det kan du göra tidigast när spelpausens tid har löpt ut.'
}];
svs.selfExclusion.accordionabtest = accordionabtest;

 })(window);